export const GET_QR_FEEDBACK_REASONS = `feedback/GET_QR_FEEDBACK_REASONS`;

export const NETWORK_REQUEST = `feedback/NETWORK_REQUEST`;

export const NETWORK_API_REQUEST = `feedback/NETWORK_API_REQUEST`;
